import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScreenNodeUptime',
  props: {
    uptimeSeconds: null
  },
  setup(__props: any) {

const props = __props as {
  uptimeSeconds: number;
};



const pulseGif = require('@/assets/my-theater/pulsing-circle.gif');

const uptimeText = computed(() => {
  if (props.uptimeSeconds === 0) return '0h00m';

  const hours = Math.floor(props.uptimeSeconds / 3600);
  const minutes = Math.floor((props.uptimeSeconds % 3600) / 60);
  return `${hours}h${minutes}m`;
});

return { __sfc: true,props, pulseGif, uptimeText }
}

})